import React from 'react'
import IMUnreadNum from './IMUnreadNum'
import useActiveState from '../../lib/useActiveState'

export default function UnreadBadge(props) {

  const [logined] = useActiveState('im-logined')
  const { active } = props;

  return (
    <div>
      {localStorage.getItem('yx_token') && localStorage.getItem('username') && logined && active && <IMUnreadNum tid={props?.tid}></IMUnreadNum>}
    </div>
  )
}
